// Client helpers for the targeted per-application notifications feature. Backed
// THIS APP'S OWN ROUTE, which it needed after all.
//
// Copied from t1 with its URL unchanged was the first bug: "t1/v1/notifications" against
// api.docs.* is a 404, and a bell that 404s looks exactly like a bell with nothing in it.
//
// Calling t2 directly was the second. data/assistant.ts says t2's authorizer accepts our token;
// MEASURED, IT DOES NOT -- a t13 access token answers 401 CC-E979-403C at both t2/v1/notifications
// and t2/v1/assistant, so the assistant has the same fault and nobody had noticed.
//
// So t13 has a thin handler and a route of its own, which is what t1 and t5 each already do.
//   GET  -> notifications applicable to the current user (+ per-user read state)
//   PUT  -> mark one ({USID}) or all ({All:true}) read
// The bell (NavBar) renders these; each notification's `notificationType` tells
// the UI what to do on click (see notificationTarget()).


// The suite application this front-end represents. Sent to the notifications
// endpoint so the bell shows notifications intended for this app or for all apps.
// WHICH APP'S BELL THIS IS. Each frontend fetches by exactly one of the values in
// cres_t2/service/notifications.py APPLICATIONS -- "Docs" was added there for t11; "Trace" for t12, and "eTMF" has to be added there for this app.
export const CURRENT_APPLICATION = "eTMF";

export type AppNotification = {
    usid: string;
    /** Apps this notification is intended for (subset of QMS/Developer/
     *  SBOM/DataCatalog); null means ALL applications. */
    applications: string[] | null;
    /** App-specific type the UI dispatches on (what to do when clicked). */
    notificationType: string;
    title: string;
    body: string;
    /** Parsed action-context JSON (may carry a `url` and type-specific fields). */
    data: any;
    /** Convenience deep link (data.url), when present. */
    url: string;
    read: boolean;
    createdDatetime: string;
};

export type NotificationsResult = {
    notifications: AppNotification[];
    unreadCount: number;
};

function toNotification(raw: any): AppNotification {
    const data = raw?.Data ?? null;
    const url = data && typeof data === "object" && data.url ? String(data.url) : "";
    return {
        usid: raw?.USID ?? "",
        applications: Array.isArray(raw?.Applications) ? raw.Applications : null,
        notificationType: raw?.NotificationType ?? "",
        title: raw?.Title ?? "",
        body: raw?.Body ?? "",
        data,
        url,
        read: !!raw?.Read,
        createdDatetime: raw?.CreatedDatetime ?? "",
    };
}

/** Notifications for the current user, newest first, plus the unread count.
 *  Scoped to this app (and all-app notifications) unless `application` is "". */
export async function fetchNotifications(api: any, application: string = CURRENT_APPLICATION): Promise<NotificationsResult> {
    const res = await api({
        method: "GET",
        url: "t13/v1/notifications",
        params: application ? {Application: application} : undefined,
    });
    const body = res?.data ?? {};
    const list = Array.isArray(body.Notifications) ? body.Notifications : [];
    return {
        notifications: list.map(toNotification),
        unreadCount: Number(body.UnreadCount) || 0,
    };
}

/** Mark a single notification read for the current user. */
export async function markNotificationRead(api: any, usid: string): Promise<void> {
    if (!usid) return;
    await api({method: "PUT", url: "t13/v1/notifications", data: {USID: usid}});
}

/** Mark every applicable notification read for the current user. */
export async function markAllNotificationsRead(api: any): Promise<void> {
    await api({method: "PUT", url: "t13/v1/notifications", data: {All: true}});
}

/**
 * Where clicking a notification should take the user, dispatched by
 * notificationType (falling back to a `url` in its data). Returning "" means no
 * navigation. Extend this as new notification types are added.
 */
export function notificationTarget(n: AppNotification): string {
    // Every Foundation notification carries its own deep link in Data.url -- the approval service
    // builds it from _ROUTES, which a test holds to covering every governed type. The switch stays
    // because the next notification kind may need to compute one; today none does.
    switch (n.notificationType) {
        default:
            return n.url || "";
    }
}
